var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionChannelsLoadingWeb = function SvgCollectionChannelsLoadingWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 1280 584"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M72 16h176v99H72z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M264 16h176v99H264z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M456 16h176v99H456z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M648 16h176v99H648z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M840 16h176v99H840z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M1032 16h176v99h-176z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M72 172h176v99H72z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M264 172h176v99H264z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M456 172h176v99H456z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M648 172h176v99H648z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M840 172h176v99H840z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M1032 172h176v99h-176z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M72 328h176v99H72z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M264 328h176v99H264z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M456 328h176v99H456z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M648 328h176v99H648z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M840 328h176v99H840z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M1032 328h176v99h-176z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M72 484h176v99H72z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M264 484h176v99H264z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M456 484h176v99H456z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M648 484h176v99H648z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M840 484h176v99H840z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M1032 484h176v99h-176z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 72,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 264,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 456,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 648,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 840,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 1032,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 72,
    y: 172,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 264,
    y: 172,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 456,
    y: 172,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 648,
    y: 172,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 840,
    y: 172,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 1032,
    y: 172,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 72,
    y: 328,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 264,
    y: 328,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 456,
    y: 328,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 648,
    y: 328,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 840,
    y: 328,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 1032,
    y: 328,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 72,
    y: 484,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 264,
    y: 484,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 456,
    y: 484,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 648,
    y: 484,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 840,
    y: 484,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 99,
    x: 1032,
    y: 484,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgCollectionChannelsLoadingWeb;